import { useEffect, useState } from 'react'
import { useSession } from 'next-auth/react'

import Resizer from 'react-image-file-resizer'

import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocationDot, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';

import errorMsg from '../../../Functions/errorMsg';
import successMsg from '../../../Functions/successMsg';

import axios from 'axios';
import { PulseLoader } from 'react-spinners';

import PolicyPage from '../../../Home/Policies/Policies';

import EditPost from './EditPost/EditPost';

import MapWithRadius from '../../../Misc/MapWithRadius/MapWithRadius';
import MapWithLocation from '../../../Misc/MapWithLocation/MapWithLocation';

export default function EditJob({ listingID, isFixing, refreshListings, closeEditor }) {

  const { data: session, status } = useSession();

  const [initialLoading, setInitialLoading] = useState(null);
  const [data, setData] = useState(null);

  const [policyPage, showPolicyPage] = useState(false);

  const [mapType, setMapType] = useState(null);

  useEffect(() => {
    if(initialLoading !== null) return;
    if(data !== null) return;
    if(status === 'loading') return;

    const requestingUser = status === 'unauthenticated' ? 'nouser' : session.user.token.username;

    async function getListingData() {
        setInitialLoading(true);

        const apiRequest = await axios.post(`${window.location.origin}/api/jobs/general/getListing`, {
          listingID: listingID,
          editData: true,
          fixData: isFixing,
          requestingUser: requestingUser
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString())
            closeEditor(null);
            setInitialLoading(false);
        })

        if(apiRequest && apiRequest.status === 200) {
          const listingData = apiRequest.data;
          setData(listingData);
        }
        setInitialLoading(false);

    }

    getListingData();

  }, [session, status])

    /* Handle Listing Create Upload */

    const [pendingRequest, setPendingRequest] = useState(false);

    async function handleEditListing(data) {
        if(pendingRequest === true) return;
        if(data === null) return errorMsg("We ran into an issue creating your post, please contact us if the issue persists.");
        if(!session || status !== 'authenticated') return errorMsg("You're not authenticated to create a post, please re-login.");
        if(typeof window === 'undefined') return;
        const heic2any = require('heic2any');

        setPendingRequest(true);

        var manipulatedData = {...data};

        const businessLogo = data.businessLogo;

        if(businessLogo?.imageFile ) {
          var fileSize = (businessLogo.imageFile.size / (1024 * 1024)).toFixed(2);
          if (fileSize > 8) {
            errorMsg("Image is too large, images can be no bigger than 8mb");
            return;
          }
  
          var resizedImage;

          if (businessLogo.imageFile.name.includes('.HEIC')) {
            const jpegBlob = await heic2any({ blob: businessLogo.imageFile, toType: 'image/jpeg' });
            resizedImage = await resizeFile(jpegBlob);
          } else {
            resizedImage = await resizeFile(businessLogo.imageFile);
          }

          manipulatedData.businessLogo = resizedImage;

        }

        const apiResult = await axios.post(`${window.location.origin}/api/jobs/dashboard/editJobListing`, { data: manipulatedData, requestingID: session.user.token.id }).catch((error) => { 
            errorMsg(error?.response?.data?.status || error.toString());
            setPendingRequest(false);
        });
      
        if(apiResult && apiResult.status === 200) {
            successMsg("Listing changes have been published.");
            setPendingRequest(false);
            closeEditor();
            refreshListings();
        }

    }

    /* END HANDLE LISTING UPLOAD */

    /* HANDLE DELETE LISTING */

    async function handleDeleteListing(listingID) {
        if(pendingRequest === true) return;
        if(!listingID) return errorMsg("We ran into an issue when deleting your listing, please try again later.");
        if(!session || status !== 'authenticated') return errorMsg("You're not authenticated to delete this post, please re-login.");

        setPendingRequest(true);

        const apiResult = await axios.post(`${window.location.origin}/api/jobs/dashboard/deleteJobListing`, {
            requestingUserID: session.user.token.id,
            jobID: listingID
        }).catch((error) => { 
            errorMsg(error?.response?.data?.status || error.toString());
            setPendingRequest(false);
        });
      
        if(apiResult && apiResult.status === 200) {
            successMsg("This post has been deleted.");
            setPendingRequest(false);
            closeEditor();
            refreshListings();
        }

    }
    
    /* END HANDLE DELETE LISTING */

    /* Handle Image Data Here */

    const resizeFile = (file) =>
    new Promise((resolve, reject) => {
      Resizer.imageFileResizer(
        file,
        1500,
        1500,
        "PNG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        200,
        200
      );
    });

    /* ==== End Handle Image Data ===== */

    function isLoading() {
        if(initialLoading === null || initialLoading === true) return true;
        if(data === null) return true;
        return false;
    }

    function handleBack() {
        closeEditor()
        setMapType(null);
    }

  return (
    <section id={styles.wrapper}>
        <div id={styles.container}>

        { policyPage === true && <section id={styles.policyContainer}> <FontAwesomeIcon onClick={() => showPolicyPage(false)} icon={faXmarkCircle} id={styles.exitPolicy} /> <PolicyPage /> </section> }

        { isLoading() === true && <span id={styles.loading}><PulseLoader size={30} color='#154734' /></span> }
        { isLoading() === false && 
        <>
            <div id={styles.form}>
              <EditPost setMapType={setMapType} handleBack={handleBack} data={data} showPolicyPage={showPolicyPage} pendingRequest={pendingRequest} closeEditor={closeEditor} handleEditListing={handleEditListing} handleDeleteListing={handleDeleteListing} />
            </div>
            <div id={styles.interactiveMap}>
              { (mapType !== null && mapType.type === 'ZIP' ) && <MapWithRadius zipCode={mapType.zip} /> }
              { (mapType !== null && mapType.type === 'Location' ) && <MapWithLocation address={mapType.address} city={mapType.city} zipCode={mapType.zip} /> }
              { mapType === null && <FontAwesomeIcon icon={faMapLocationDot} id={styles.icon} /> }
            </div>
        </>
        }

        </div>
    </section>
  )
}